<template>
  <span
    class="bg-pw-orange text-pw-ink after:bg-pw-paper relative grid h-8 w-8 place-items-center rounded-[2px] font-mono text-base font-bold after:absolute after:-right-[3px] after:-bottom-[3px] after:size-2 after:content-['']"
    >F</span
  >
</template>
